import React, {useState, useEffect} from 'react';
import { Form, Input, Button, message, Space, Typography } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import './index.css'; // Optional: For additional custom styling
import auth from '../../services/auth';

const { Text } = Typography;


const testimonials = [
  {
    text: 'LeadSlope has transformed my sales process. I\'ve been able to grow and maintain our pipeline with new and workable life leads. The first week of buying leads I closed 2 deals with a $6,600 APV. Highly recommended!',
    name: 'Matt Godek',
    title: 'Life Agent - Symmetry Financial',
  },
  {
    text: 'I finally found a life lead company that does not require upfront costs and a true pay per lead. High quality and the right amount of data submitted by the consumer. My first deal with them was for $2,200 in APV and it cost me $6. LOVE IT!',
    name: 'Taylor Holdernan',
    title: 'Family First Financial',
  },
  {
    text: 'This is the only way to go when buying life leads. I get a huge return on a minimal budget and only pay for what I need that day. I\'ve closed 2 deals my first week of buying leads!',
    name: 'Eric Bowlby',
    title: 'Bennett and Associates',
  },
];

const Register = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [testimonialIdx, setTestimonialIdx] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTestimonialIdx((idx) => (idx + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const testimonial = testimonials[testimonialIdx];

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await auth.register(values);
      message.success('Registration successful!');
      navigate('/login');
    } catch (error) {
      setLoading(false);
      console.error('Registration Error:', error);
      if (error.response && error.response.data && error.response.data.message) {
        if (error.response.data.message === 'Email already exists') {
          message.error('Email already exists. Please use a different email.');
        } else {
          message.error(error.response.data.message);
        }
      } else {
        message.error('Registration failed. Please try again.');
      }
    }
  };

  return (
    <div className="split-container">
      {/* Left Side */}
      <div className="split-left">
        <img src="/leadslope-logo.jpg" alt="LeadSlope Logo" style={{ width: 200, display: 'block', margin: '0 auto 32px auto' }} />
        <div className="testimonial-slider">
          <div className="testimonial-text center">
            <p>"{testimonial.text}"</p>
            <span className="testimonial-author center">{testimonial.name}</span>
            <span className="testimonial-title center">{testimonial.title}</span>
          </div>
          <div className="testimonial-dots">
            {testimonials.map((_, i) => (
              <span key={i} className={i === testimonialIdx ? 'dot active' : 'dot'}></span>
            ))}
          </div>
        </div>
      </div>
      {/* Right Side */}
      <div className="split-right">
        <Form
          name="register_form"
          className="register-form"
          onFinish={onFinish}
        >
          <h2 className="register-title">Register Now</h2>
          <div className="register-subtitle">Buy the complete Lead Management System for your business.</div>
          {/* First and Last Name in one line */}
          <div className="name-row">
            <Form.Item
              name="name"
              rules={[
                { required: true, message: 'Please input your name!' },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="First Name"
              />
            </Form.Item>
            <Form.Item
              name="last_name"
              rules={[
                { required: true, message: 'Please input your last name!' },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Last Name"
              />
            </Form.Item>
          </div>
          
          <Form.Item
            name="email"
            rules={[
              { type: 'email', message: 'The input is not a valid email address!' },
              { required: true, message: 'Please input your email!' },
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Email"
            />
          </Form.Item>


          <Form.Item
              name="phone"
              rules={[
                { required: true, message: 'Please input your phone number!' },
              ]}
            >
              <Input
                prefix={<PhoneOutlined />}
                placeholder="Phone"
              />
            </Form.Item>

            {/* <Form.Item
              name="address"
              rules={[
                { required: true, message: 'Please input your address!' },
              ]}
            >
              <Input
                prefix={<EnvironmentOutlined />}
                placeholder="Address"
              />
            </Form.Item> */}
          
          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Please input your password!' },
              { min: 6, message: 'Password must be at least 6 characters long!' },
            ]}
            hasFeedback
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
            />
          </Form.Item>
          
          <Form.Item
            name="confirmPassword"
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: 'Please confirm your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('The two passwords do not match!')
                  );
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Confirm Password"
            />
          </Form.Item>
       
          
          <Form.Item>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              className="register-form-button"
            >
              Register
            </Button>
          </Form.Item>

          {/* <div className="security-message">
            <span role="img" aria-label="lock">🔒</span> Your connection to this site is secure and your information is protected.
          </div> */}

          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Form.Item>
             
              <Link to="/login">
                <Button type="link" className="sign-in-button" style={{ marginLeft: 8 }}>
                Have an account? Login
                </Button>
              </Link>
            </Form.Item>
            <Form.Item >
            </Form.Item>
          </Space>

          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              By registering, you agree to our{' '}
              <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
                Terms
              </a>
              {' '}and{' '}
              <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
                Terms of Service
              </a>
            </Text>
          </div>

        </Form>
      </div>
    </div>
  );
};

export default Register;
